/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface SkillMapCellTargetResetPayload {
    cmId: string;
    cmcId: string;
    comment?: string;
}

export interface SkillMapCellTargetResetResponse {
    skillMapName: string;
    updateTime: string;
    updator: string;
}

class SkillMapCellTargetResetService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "skillMapCellTargetReset");
    }

    public async skillMapCellTargetReset(
        payload: SkillMapCellTargetResetPayload,
        resolved: (response: SkillMapCellTargetResetResponse) => void,
        rejected: (error: any) => void
    ) {
        await super.postJSON(
            payload,
            (json: any) => {
                const response = json as SkillMapCellTargetResetResponse;
                resolved(response);
            },
            rejected
        );
    }
}

export default SkillMapCellTargetResetService;
